// removed by extract-text-webpack-plugin
module.exports = {"container":"container-3claX","elevation":"elevation-2upBg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/routes/print/_elevation.css
// module id = 1266
// module chunks = 1